import { useState, useCallback } from "react";
import {
  NotificationMessage,
  Severity
} from "../../components/notificationMessage/NotificationMessage";

export const useToastNotification = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<Severity>("info");
  const showNotification = useCallback((msg: string, sev: Severity) => {
    setVisible(false);
    setTimeout(() => {
      setMessage(msg);
      setSeverity(sev);
      setVisible(true);
    }, 100);
  }, []);
  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);
  const NotificationElement = (
    <NotificationMessage
      message={message}
      severity={severity}
      visible={visible}
      onClose={handleClose}
    />
  );
  return { showNotification, NotificationElement };
};
